import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';
import { trackEntityById } from 'projects/core/src/public-api';
import { PartGroup } from 'projects/cart-tv/src/app/data/parts/part-group';
import { Subject, timer } from 'rxjs';
import { Part } from 'projects/cart-tv/src/app/data/parts/part';
import { debounceTime } from 'rxjs/operators';
import { CartsService } from 'projects/cart-tv/src/app/data/cart.sevice';

@Component({
  selector: 'app-finishing-parts',
  templateUrl: './finishing-parts.component.html',
  styleUrls: ['./finishing-parts.component.scss']
})
export class FinishingPartsComponent implements OnInit, OnDestroy {
  @Input()
  project: Project

  @Input()
  partGroups: PartGroup[];

  @Input()
  booleanString: string;

  @Input()
  isMobile: boolean;

  @Output()
  scrollToFileEmitter = new EventEmitter<Cabinet>()

  @Output()
  toggleCabinetStatusEmitter = new EventEmitter<Cabinet>()

  @Output()
  savePart = new EventEmitter<Part>()

  @Output()
  deleteItemEmitter = new EventEmitter<number>();

  savePartSubj = new Subject<Part>()
  saveGroupSubj = new Subject<PartGroup>()

  trackEntityById = trackEntityById;

  constructor(
    private cartService: CartsService,
    private el: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.savePartSubj.pipe(debounceTime(250)).subscribe(part => {
      this.cartService.savePart(part as Part)
      .subscribe(cab => {
      })
    })
    this.saveGroupSubj.pipe(debounceTime(250)).subscribe(group => {
      this.cartService.savePartGroup(group as PartGroup)
      .subscribe(cab => {
      })
    })
  }

  toggleCabinetStatus(cabinet: Cabinet) {
    this.toggleCabinetStatusEmitter.emit(cabinet)
  }

  scrollToFile(cabinet: Cabinet) {
    this.scrollToFileEmitter.emit(cabinet)
  }

  deleteCabinet(index: number) {
    this.deleteItemEmitter.emit(index)
  }

  colorNoteInput(part: Part) {
    this.savePartSubj.next(part)
  }

  groupNoteInput(group: PartGroup) {
    this.saveGroupSubj.next(group)
  }

  addNote(part: Part, index: number) {
    part.colorNote = 'Note';

    timer(1).subscribe(emit => {
      const elems = this.el.nativeElement.getElementsByClassName('from-parts');
      if(elems && elems[index]) {
        const elem = elems[index];
        const inputs = elem.getElementsByClassName('arrow-input')
        if(inputs && inputs[0]) {
          inputs[0].focus()
          inputs[0].setSelectionRange(0, part.colorNote.length);
        }
      }
    })

  }

  clearNoteInput(part: Part) {
    part.colorNote = undefined;
  }

  ngOnDestroy() {
    this.savePartSubj.unsubscribe()
    this.savePartSubj = null;
    this.saveGroupSubj.unsubscribe()
    this.saveGroupSubj = null;
  }
}
